// Pinned above the composer once the engine's crisis_signpost tool fires.
// The wording is fixed copy from the locale files (config/locales), never
// model output, and the block cannot be dismissed for the rest of the
// conversation.

type Props = {
  heading: string
  body: string
  lines: string[]
}

export function CrisisBlock({ heading, body, lines }: Props) {
  return (
    <div
      role="alert"
      data-testid="assistant-crisis"
      className="callout mx-3 mb-2 border border-hairline bg-surface px-3 py-2"
    >
      <strong>{heading}</strong>
      <p className="mt-1">{body}</p>
      <ul className="mt-1 list-disc pl-4">
        {lines.map((line) => (
          <li key={line}>{line}</li>
        ))}
      </ul>
    </div>
  )
}
